export const appSettingsAllTags = "/app_settings/all_tags";
